/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EnsureFirstPartyMcpGrantResponse
 */
export interface EnsureFirstPartyMcpGrantResponse {
    /**
     * 
     * @type {string}
     * @memberof EnsureFirstPartyMcpGrantResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof EnsureFirstPartyMcpGrantResponse
     */
    scope: string;
}

/**
 * Check if a given object implements the EnsureFirstPartyMcpGrantResponse interface.
 */
export function instanceOfEnsureFirstPartyMcpGrantResponse(value: object): value is EnsureFirstPartyMcpGrantResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    return true;
}

export function EnsureFirstPartyMcpGrantResponseFromJSON(json: any): EnsureFirstPartyMcpGrantResponse {
    return EnsureFirstPartyMcpGrantResponseFromJSONTyped(json, false);
}

export function EnsureFirstPartyMcpGrantResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnsureFirstPartyMcpGrantResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['client_id'],
        'scope': json['scope'],
    };
}

export function EnsureFirstPartyMcpGrantResponseToJSON(json: any): EnsureFirstPartyMcpGrantResponse {
    return EnsureFirstPartyMcpGrantResponseToJSONTyped(json, false);
}

export function EnsureFirstPartyMcpGrantResponseToJSONTyped(value?: EnsureFirstPartyMcpGrantResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'client_id': value['clientId'],
        'scope': value['scope'],
    };
}

